import { computed, onBeforeMount, ref } from 'vue'
import SupportSelector from '../SupportSelector/SupportSelector.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import _stafetCommonStepsProps from '../../foundation/js/configurations/_stafetCommonStepsProps'
import { useStore } from 'vuex'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDonationTaendLysStepOne',
    components: {
        SupportSelector,
        FormInputTextField,
        FormInputDropdown,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const donationAmount = ref(0)
        const amount = ref(props.lysposeMinimumAmount)
        const supportSelector = ref({})

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'donationAmount')) {
                    donationAmount.value = getFieldValue(
                        storedFields,
                        'donationAmount'
                    )
                }

                if (getFieldValue(storedFields, 'amount')) {
                    amount.value = getFieldValue(storedFields, 'amount')
                }

                if (getFieldValue(storedFields, 'donationFor')) {
                    store.dispatch('donation/donationFor', {
                        donationFor: getFieldValue(storedFields, 'donationFor')
                    })
                }

                if (getFieldValue(storedFields, 'donationTeam')) {
                    store.dispatch('donation/donationTeam', {
                        team: getFieldValue(
                            storedFields,
                            'donationTeam'
                        ).toString()
                    })
                }

                if (getFieldValue(storedFields, 'donationParticipant')) {
                    store.dispatch('donation/donationParticipant', {
                        participant: getFieldValue(
                            storedFields,
                            'donationParticipant'
                        )
                    })
                }
            }
        })

        const stepModel = computed(() => {
            return [
                {
                    name: 'donationAmount',
                    value: parseInt(donationAmount.value),
                    isValid: false,
                    validator: (value) => {
                        return value > 0
                    }
                },
                {
                    name: 'amount',
                    value: parseInt(amount.value),
                    isValid: false,
                    validator: (value) => {
                        return donationAmount.value > 0
                            ? value >= props.lysposeMinimumAmount
                            : true
                    }
                },
                {
                    name: 'donationFor',
                    value: supportSelector.value.donationFor,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'donationTeam',
                    value: supportSelector.value.donationTeam,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'donationParticipant',
                    value: supportSelector.value.donationParticipant,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                }
            ]
        })

        const updateSupportSelector = (data) => {
            supportSelector.value = data
        }

        const setDonationPerLightBag = (value) => {
            amount.value = value
        }

        const showDonationAmoutErrorMessage = computed(() => {
            return props.displayInputError && donationAmount.value <= 0
        })

        const showDonationPerLightBagErrorMessage = computed(() => {
            return (
                props.displayInputError &&
                amount.value < props.lysposeMinimumAmount
            )
        })

        return {
            donationAmount,
            amount,
            stepModel,
            updateSupportSelector,
            setDonationPerLightBag,
            showDonationAmoutErrorMessage,
            showDonationPerLightBagErrorMessage
        }
    }
}
